import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getHelpFilesNav: () => NavRoute = () => ({
	name: 'Help'
    , href: 'help'
    , icon: faQuestionCircle
    , area: 'help'
    , expanded: globalThis.location.href.includes("/help")
    , children: [
		{
			name: 'Help Documents'
			, exact: true
			, path: 'help'
            , activeNavLink: 'help'
            , secondaryNav: [ 'Help', 'Help Documents' ]
		}
	]
});